import React from 'react';

import {Schema} from 'schemas/SchemaConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

import {AddColumnTransform} from '../../RunSchemaSpecConstants';
import LookupConfigInput from './LookupConfigInput';
import {AddColumnFormErrors, updateTransformationProperties} from './TransformFormUtils';

interface AddColumnFormProps {
  baseSchema: Schema;
  transform: AddColumnTransform;
  onChange: (transform: AddColumnTransform) => void;
  formErrors: AddColumnFormErrors;
}

export default function AddColumnForm(props: AddColumnFormProps): JSX.Element {
  return (
    <Row>
      <Col md={4}>
        <TextField
          label="Column name"
          onChange={(e) => {
            props.onChange(updateTransformationProperties(props.transform, 'column', e.target.value));
          }}
          labelStyle={FieldLabel.STYLES.LABEL}
          isRequired={true}
          value={props.transform.transformationProperties?.column}
          hasError={props.formErrors.column}
        />
        {props.formErrors.column ? <ErrorMessage error="Column name is required" /> : null}
      </Col>
      <Col md={4}>
        <FieldLabel label="Set column value" labelStyle={LabelStyle.LABEL} isRequired={true} />
        <LookupConfigInput
          baseSchema={props.baseSchema}
          transform={props.transform}
          onChange={props.onChange}
          shouldShowIsMulti={true}
        />
        {props.formErrors.lookupConfig ? <ErrorMessage error="Lookup is required" /> : null}
      </Col>
    </Row>
  );
}
